import q from 'q'
import Metrics from '../services/metrics'

export default {
  /**
   * downloads a resource without triggering the clients popup blockers
   * @param url - url of the resource
   */
  initiate(url) {
    let deferred = q.defer()

    let xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onprogress = progress => {
      if (progress.lengthComputable) {
        let percentComplete = (progress.loaded / progress.total) * 100
        deferred.notify(percentComplete)
      }
    }
    xhr.onload = load => {
      if (load.srcElement.status === 200) {
        deferred.resolve(load.srcElement.response)
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.DOWNLOAD_RESOURCE_SUCCESS, 1, Metrics.TYPE.OCCURRENCE_COUNTER)
      } else {
        const statusError = new Error('status: ' + load.srcElement.status)
        Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.DOWNLOAD_RESOURCE_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, statusError)
        deferred.reject(statusError)
      }
    }
    xhr.onerror = error => {
      Metrics.sendMetric(Metrics.CATEGORIES.THIRD_PARTY_CALLS, Metrics.CP_TAGS.DOWNLOAD_RESOURCE_ERROR, 1, Metrics.TYPE.FAILURE_COUNTER, error)
      deferred.reject(new Error('error: ' + error))
    }
    xhr.send()

    return deferred.promise
  }
}
